import { BaseOption, SelectValueType } from 'ui/selects';
import { SelectOption } from 'modules/queryBuilder/contexts/visualComponents';
import { getBaseOptionConverter } from './getBaseOptionConverter';

/** util to convert select options from queryBuilder to base options from 'ui/select' */
export const convertToBaseOptions = <T extends SelectValueType = string>(
  options: SelectOption<T>[],
  isMultiselect?: boolean,
): BaseOption<T>[] => {
  const converter = getBaseOptionConverter<T>(!!isMultiselect);
  return options.map(converter);
};
